import React from "react";

/**
 * StatusBadge
 * Unified status pill for analyses, reports, and models.
 *
 * Props:
 * - status: string
 * - size?: "sm" | "md"
 */
function StatusBadge({ status, size = "md" }) {
  if (!status) {
    return null;
  }

  const normalized = String(status).toUpperCase();

  const classesByStatus = {
    DRAFT: "badge-draft",
    PENDING: "badge-pending",
    RUNNING: "badge-running",
    COMPLETED: "badge-completed",
    FAILED: "badge-failed",
    PUBLISHED: "badge-completed",
    ARCHIVED: "badge-draft",
  };

  const cls = classesByStatus[normalized] || "badge-draft";

  return (
    <span className={`status-badge ${cls} status-badge-${size}`}>
      {normalized.replace(/_/g, " ")}
    </span>
  );
}

export default StatusBadge;

